import { TextInputFloating } from '@zoom/components';
import classnames from 'classnames';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputProps } from 'reactstrap';

export type RenderInputProps = InputProps &
  FieldRenderProps<string> & {
    dataTestId?: string;
    disabled?: boolean;
    label?: string;
  };

export const finalFormInputHelper = (
  inputProps: InputProps & { dataTestId?: string; label?: string },
  disabled?: boolean
) => (fieldRenderProps: FieldRenderProps<string>) => (
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  <RenderInput disabled={disabled} {...inputProps} {...fieldRenderProps} />
);

export const RenderInput: React.FC<RenderInputProps> = ({
  dataTestId,
  disabled = false,
  input: { name, onChange, value, type, ...inputProps },
  meta,
  label,
}) => {
  const className = classnames('text-input', {
    'text-input--valid': (!meta.pristine && meta.valid) || (value && !meta.dirty && !disabled),
    'text-input--invalid': meta.dirty && meta.error,
    'text-input--disabled': disabled,
  });
  const onBlurHandler = () => !value && meta.pristine && onChange('');

  return (
    <div className={className} data-test-id={dataTestId && `${dataTestId}-wrapper`}>
      <TextInputFloating
        data-test-id={dataTestId}
        label={label}
        disabled={disabled}
        {...inputProps}
        type={type as InputProps['type']}
        id={name}
        name={name}
        onChange={onChange}
        onBlur={onBlurHandler}
        value={value}
      />
    </div>
  );
};
